export default __webpack_public_path__ + "static/media/loss-analysis-step-7.6530acb3.gif";